import Reveal from "@/components/base/Reveal";
import { brandPoints, reviews } from "@/mocks/dailyContest";

export default function About() {
  return (
    <section id="about" className="border-b border-background-300/70 bg-background-50 py-12 md:py-16">
      <div className="container-x">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-team-fill" aria-hidden="true" />
              关于每日大赛网
            </span>
            <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              把选秀看得更透的编辑部
            </h2>
            <p className="mt-4 text-[15px] leading-7 text-foreground-600">
              每日大赛网由一群长期追选秀、做数据复盘与内容考据的编辑组成。我们意识到：票池规则藏在公告角落、
              直拍版本各有千秋、热议事件散落各处——普通观众很难一次看全。于是我们决定做一个
              <span className="font-semibold text-foreground-800">专门为吃瓜群众整理选秀全程</span>的站点：
              直播结束即盘点、规则一改就更新、争议一律摆证据。我们保持中立、客观与时效，
              让每一次打榜与吃瓜都建立在看得懂的信息之上。
            </p>
          </div>
        </Reveal>

        {/* brand points */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {brandPoints.map((b, i) => (
            <Reveal key={b.title} delay={i * 60}>
              <div className="flex h-full flex-col rounded-lg border border-background-300/70 bg-background-100 p-5 transition-colors hover:border-primary-300">
                <span className="headline-en text-3xl font-black text-primary-500/30">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 font-serif text-lg font-bold text-foreground-950">{b.title}</h3>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* testimonials */}
        <Reveal delay={80}>
          <div className="mt-12 flex items-center gap-3">
            <h3 className="font-serif text-2xl font-bold text-foreground-950">读者口碑</h3>
            <span className="rule-line flex-1" />
          </div>
        </Reveal>
        <div className="mt-6 grid gap-5 md:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 70}>
              <figure className="flex h-full flex-col rounded-lg border border-background-300/70 bg-background-100 p-5 md:p-6">
                <div className="flex gap-1 text-accent-500" aria-label="五星评价">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <i key={s} className="ri-star-fill text-sm" aria-hidden="true" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-[14px] leading-7 text-foreground-800">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center justify-between border-t border-background-300/60 pt-3">
                  <div>
                    <div className="text-sm font-bold text-foreground-900">{r.name}</div>
                    <div className="text-xs text-foreground-500">{r.role}</div>
                  </div>
                  <span className="chip bg-secondary-100 text-secondary-800">{r.tag}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}